"use client";

import AppConfigContext, { useConfigContext } from '../lib/context/AppConfig';
import { useAppStore } from '../lib/hooks';
import { configLoaded } from '../lib/model/config/configSlice';
import { PropsWithChildren, useEffect } from 'react';

export default function ConfigProvider({children}: PropsWithChildren) {
    return (
        <AppConfigContext>
            <AppConfigState>
                {children}
            </AppConfigState>
        </AppConfigContext>
    )
}

function AppConfigState({children}: PropsWithChildren) {
    const config = useConfigContext()
    const store = useAppStore();

    useEffect(() => {
        store.dispatch(configLoaded(config))
    }, [config, store])

    return (
        <>
            {children}
        </>
    )
}
